import Roles from '@/entities/Roles';

export default (userRole?: string): Object => {
  const baseConditions = [
    {
      approved: {
        _eq: true,
      },
    },
    {
      deleted: {
        _eq: false,
      },
    },
  ];

  if (userRole === Roles.MANAGER) {
    return {
      _and: [
        {
          managers: {
            approved: {
              _eq: true,
            },
          },
        },
        ...baseConditions,
      ],
    };
  }

  return {
    _and: [...baseConditions],
  };
}